export default {
  name: 'third',
  data: function() {
    return {
      showInfo: false
    }
  },
  props: ['connectText', 'overview'],
  methods: {
    goTo: function() {
      let id = this.$route.params.id
      this.$router.push({
        name: 'install',
        params: {
          id
        }
      })
    }
  },
  beforeMount: function() {

  }
}


// WEBPACK FOOTER //
// ./src/components/connect/subComponents/third/third.js